import React from "react";
import { FaUsers } from "react-icons/fa";
import {
  AiOutlineUserAdd,
  AiOutlineShoppingCart,
  AiOutlineStock,
} from "react-icons/ai";
import { MdSubject } from "react-icons/md";
import { GoFileSubmodule } from "react-icons/go";
import { HiUserGroup } from "react-icons/hi";
import { TbReport } from "react-icons/tb";
import { Link } from "react-router-dom";
import "./DashboardHome.css";
import { getuser } from "../../components/CommonDateFormat";

const DashbordHome = () => {
  const user = getuser();

  return (
    <div className="bg-[#F4F6F9] h-[90vh]  p-4 pt-10 lg:pt-4 background-image">
      <div className="hidden grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-8">
        <Link to="/dashboard/category" className="zindexFixed">
          <div className="flex flex-col items-center px-4 py-5 gap-y-4 bg-white font-bold text-blue-600 shadow-md rounded">
            <span className="w-full rounded py-2 bg-blue-600">
              <MdSubject className="text-2xl text-white block m-auto" />
            </span>

            <p> Category</p>
          </div>
        </Link>
        <Link to="/dashboard/sub_category" className="zindexFixed">
          <div className="flex flex-col items-center px-4 py-5 gap-y-4 bg-white font-bold text-blue-600 shadow-md rounded">
            <span className="w-full rounded py-2 bg-indigo-700">
              <GoFileSubmodule className="text-2xl text-white block m-auto" />
            </span>
            <p> Sub-Category</p>
          </div>
        </Link>
        <Link to="/dashboard/product" className="zindexFixed">
          <div className="flex flex-col items-center px-4 py-5 gap-y-4 bg-white font-bold text-blue-600 shadow-md rounded">
            <span className="w-full rounded py-2 bg-purple-600">
              <AiOutlineShoppingCart className="text-2xl text-white block m-auto" />
            </span>
            <p> Product</p>
          </div>
        </Link>
        {user?.role === "admin" && (
          <Link to="/dashboard/user" className="zindexFixed">
            <div className="flex flex-col items-center px-4 py-5 gap-y-4 bg-white font-bold text-blue-600 shadow-md rounded">
              <span className="w-full rounded py-2 bg-cyan-600">
                <AiOutlineUserAdd className="text-2xl text-white block m-auto" />
              </span>
              <p> User</p>
            </div>
          </Link>
        )}

        <Link to="/dashboard/orders" className="zindexFixed">
          <div className="flex flex-col items-center px-4 py-5 gap-y-4 bg-white font-bold text-blue-600 shadow-md rounded">
            <span className="w-full rounded py-2 bg-amber-600">
              <AiOutlineShoppingCart className="text-2xl text-white block m-auto" />
            </span>
            <p> Invoice</p>
          </div>
        </Link>
        <Link to="/dashboard/dealer" className="zindexFixed">
          <div className="flex flex-col items-center px-4 py-5 gap-y-4 bg-white font-bold text-blue-600 shadow-md rounded">
            <span className="w-full rounded py-2 bg-lime-600">
              <HiUserGroup className="text-2xl text-white block m-auto" />
            </span>
            <p>Dealer</p>
          </div>
        </Link>
        <Link to="/dashboard/supplier" className="zindexFixed">
          <div className="flex flex-col items-center px-4 py-5 gap-y-4 bg-white font-bold text-blue-600 shadow-md rounded">
            <span className="w-full rounded py-2 bg-orange-700">
              <FaUsers className="text-2xl text-white block m-auto" />
            </span>
            <p>Supplier</p>
          </div>
        </Link>
        <Link to="/dashboard/report/purchase" className="zindexFixed">
          <div className="flex flex-col items-center px-4 py-5 gap-y-4 bg-white font-bold text-blue-600 shadow-md rounded">
            <span className="w-full rounded py-2 bg-orange-600">
              <TbReport className="text-2xl text-white block m-auto" />
            </span>
            <p>All-Report</p>
          </div>
        </Link>
        <Link to="/dashboard/report/stock" className="zindexFixed">
          <div className="flex flex-col items-center px-4 py-5 gap-y-4 bg-white font-bold text-blue-600 shadow-md rounded">
            <span className="w-full rounded py-2 bg-emerald-600">
              <AiOutlineStock className="text-2xl text-white block m-auto" />
            </span>
            <p>Stock</p>
          </div>
        </Link>
      </div>
      <div className="overlay"></div>
    </div>
  );
};

export default DashbordHome;
